import { Dispatch } from "redux";
import {
  ERROR_LOADING_LIMITED_NOTIFICATIONS,
  GET_LIMITED_NOTIFICATIONS,
  RESET_LIMITED_NOTIFICATIONS,
  START_LOADING_LIMITED_NOTIFICATIONS,
  STOP_LOADING_LIMITED_NOTIFICATIONS,
} from "./action-types";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import { IFetchLimitedNotifications } from "./initialState";

export const fetchLimitedNotificationsAction =
  (calledViaInterval: boolean = false) =>
  async (dispatch: Dispatch, getState: any) => {
    if (!calledViaInterval) {
      dispatch({ type: START_LOADING_LIMITED_NOTIFICATIONS });
    }

    try {
      const response: IFetchLimitedNotifications =
        await apiLibrary.NotificationCenter.getLimitedNotifications();

      const { notifications, unreadNotificationCount } = response.data;

      dispatch({
        type: GET_LIMITED_NOTIFICATIONS,
        payload: { notifications, unreadNotificationCount },
        message: response.message,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);

      dispatch({
        type: RESET_LIMITED_NOTIFICATIONS,
      });
      console.log("An error occurred while fetching the notifications:", error);
      dispatch({ type: ERROR_LOADING_LIMITED_NOTIFICATIONS });
    } finally {
      dispatch({ type: STOP_LOADING_LIMITED_NOTIFICATIONS });
    }
  };
